import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewPageContentLayer from "../components/ViewPageContentLayer";

const ViewContentPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Page Content Details' />

        {/* AddBlogLayer */}
        <ViewPageContentLayer />
      </MasterLayout>
    </>
  );
};

export default ViewContentPage;